module.exports = __webpack_public_path__ + "static/media/wappen.ffa5c3ef.png";


//////////////////
// WEBPACK FOOTER
// /src/images/wappen.png
// module id = 1616
// module chunks = 0